const self = {
  public: {
    tooltip: "Public resources appear in the marketplace",
    label: "Public or Private",
    rules: "required",
  },
  title: {
    placeholder: "Title",
    label: "Title",
    tooltip: "The title of your picture",
    rules: "required",
  },
  provider: {
    placeholder: "Provider",
    label: "Provider",
    tooltip: "Who created this picture?",
    rules: "required",
  },
  license: {
    placeholder: "Licenses",
    label: "Licenses",
    tooltip: "The license of your picture",
    rules: "required",
    enum: [
      "MIT",
      "Apache license 2.0",
      "Artistic license 2.0",
      "ISC",
      "Open Software License 3.0",
    ],
    maxlength: 15,
  },
  tags: {
    placeholder: "Tags",
    label: "Tags",
    tooltip: "Keywords that describe your picture",
    rules: "",
    allowNew: true,
    maxlength: 15,
  },
  description: {
    label: "Description",
    placeholder: "Tell us about your picture",
    rules: "",
    maxlength: 2500,
    tooltip: "Describe your picture",
  },
};

export default self;
